import React, { PropsWithChildren } from 'react';

import { isDisabled } from 'app/infrastructure/data/date';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { Tag } from 'app/components/tag';

import { GenericSavedReport } from '../../types-store';

import styles from './saved-report-tile-header.scss';

export const SavedReportTileHeader = <SavedReport extends GenericSavedReport>({
  savedReport, canDrag, disabledLabel
}: PropsWithChildren<{
  savedReport: SavedReport;
  canDrag: boolean;
  disabledLabel: string;
}>) => {

  return !!savedReport && <>
    {canDrag && <div className={styles.dragSymbol} />}
    {isDefinedIncludingZero(savedReport.code?.value) && <div className={styles.tileId}>
      #{savedReport.code?.value}
    </div>}
    <h3 className={styles.tileTitle}>{savedReport.code?.description}</h3>
    {isDisabled(savedReport.disabled)
      ? <Tag className={styles.disabledTag}>
        {disabledLabel}
      </Tag>
      : null}
  </>;
};
